// extracted by mini-css-extract-plugin
export var accent = "_8x-4";
export var add = "_8x-j";
export var addIcon = "_8x-k";
export var deleteIcon = "_8x-i";
export var disabled = "_8x-9";
export var ellipsis = "_8x-f";
export var error = "_8x-3";
export var form = "_8x-5";
export var hideFocus = "_8x-2";
export var icon = "_8x-7";
export var input = "_8x-e";
export var listItem = "_8x-h";
export var mediumHeight = "_8x-b";
export var noBorder = "_8x-8";
export var noRadius = "_8x-1";
export var shortHeight = "_8x-a";
export var tallHeight = "_8x-c";
export var textInput = "_8x-0";
export var vertical = "_8x-g";
export var veryTallHeight = "_8x-d";
export var widget = "_8x-6";